import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { Grid, Col, Row, ProgressBar } from 'react-bootstrap';

import './SystemStatus.css';

const SystemStatus = () => {
  const [status, setStatus] = useState('loading');
  const [statusPercentage, setStatusPercentage] = useState(0);
  const [statusDate, setStatusDate] = useState('Unknown');

  useEffect(() => {
    document.title = 'System Status | CVM Insights';

    const fetchData = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_PORTAL_API}v1/pdt-status-check`
        );
        const json = await response.json();
        if (json.success === true) {
          setStatusDate(
            moment(json.data.date)
              .utc()
              .format('MMMM DD, YYYY')
          );
          setStatus(json.data.status);
          let percentage = (json.data.success / json.data.total) * 100;
          setStatusPercentage(+percentage.toFixed(2));
        }
      } catch (error) {
        console.log('error', error);
      }
    };
    fetchData();
  }, []);
  //setInterval(fetchData, 60000);

  return (
    <section className="tvt-main__content">
      <Grid fluid componentClass="section">
        <Row>
          <Col md={12}>
            <div className="row tvt-systemstatus-container text-center">
              <div className="col-xs-12 col-sm-10 col-sm-offset-1">
                <h1>System Status</h1>

                <div className={status === 'loading' ? 'loading' : 'hidden'}>
                  <i className="fa fa-spinner fa-pulse fa-3x fa-fw loading-hidden"></i>
                </div>

                <div className={status === 'success' ? 'success' : 'hidden'}>
                  <div className="alert alert-success">
                    <strong>Completed! </strong>
                    The data in CVMi is up to date.
                  </div>
                  <ProgressBar bsStyle="success" label="100%" now={100} />
                </div>

                <div className={status === 'building' ? 'info' : 'hidden'}>
                  <div className="alert alert-info">
                    <strong>In Progress! </strong>
                    The data in CVMi is actively refreshing. See refresh
                    progress below.
                  </div>
                  <ProgressBar
                    bsStyle="info"
                    label={`${statusPercentage}%`}
                    now={statusPercentage}
                  />
                </div>

                <div className={status === 'error' ? 'danger' : 'hidden'}>
                  <div className="alert alert-danger">
                    <strong>Notice! </strong>
                    We are currently experiencing an issue with our data
                    processing system, causing some data to be temporarily
                    unavailable. Our team is actively resolving the issue and we
                    apologize for any inconvenience this may cause.
                  </div>
                  <ProgressBar bsStyle="danger" label="⚠" now={100} />
                </div>

                <p
                  className={
                    status === 'building'
                      ? 'hidden'
                      : 'tvt-systemstatus-availablethrough'
                  }
                >
                  Data available through <strong>{statusDate}</strong>
                </p>
                <p>
                  Data on CVMi is updated daily to enable up-to-date results and
                  insights. If you have any questions, please contact us at{' '}
                  <a href="mailto:insights-support@whipmedia.com">
                    insights-support@whipmedia.com
                  </a>
                  . Or, of course, feel free to reach out to your CVM Insights
                  representative with any questions.
                </p>
              </div>
            </div>
          </Col>
        </Row>
      </Grid>
    </section>
  );
};

export default SystemStatus;
